<template>
  <div class="smart container">
    <div class="banner container">
      <div class="banner1">
        <img src="../assets/img/banner_SmartPark.png" alt="" />
        <img src="../assets/img/btn_banner_SmartPark.png" @click="$store.commit('PageIds', true)" />
      </div>
    </div>
    <!--  农贸市场经营五大思考  -->
    <div class="think_box">
      <div class="app-main">
        <div class="wholesale_programme_title1">
          <div class="wholesale_programme_title_text1 wholesale_programme_title_text2">
            农贸市场经营五大思考
            <img src="../assets/img/title3@2x.png" alt="" />
          </div>
          <div class="zhexian"></div>
        </div>
        <div class="think_container">
          <div class="think_item">
            <img src="../assets/img/queren.png" alt="" />
            消费客流量增长
          </div>
          <div class="think_item">
            <img src="../assets/img/queren.png" alt="" />
            商户交易增长
          </div>
          <div class="think_item">
            <img src="../assets/img/queren.png" alt="" />
            市场经营增长
          </div>
          <div class="think_item">
            <img src="../assets/img/queren.png" alt="" />
            民生保障增长
          </div>
          <div class="think_item">
            <img src="../assets/img/queren.png" alt="" />
            社会效应增长
          </div>
        </div>
      </div>
    </div>
    <!--  智慧农贸解决方案  -->
    <div class="banners">
      <div class="wholesale_programme_title">
        <div class="wholesale_programme_title_text">
          智慧农贸解决方案
          <img src="../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>

      <div class="wholesale_text">
        <p>禾平数据为农贸市场的转型升级提供智慧数字化运营服务，整体方案完全采用最新的模式，</p>
        <p>
          几乎涵盖了农贸市场管理的所有维度，大大小小百余项功能架构，减少人工成本的投入，大大提高市场的管理和运营效率。
        </p>
        <p>
          从根本上解决市场数据难采集、不完整的问题，通过前端配置的智能化设备采集的数据，彻底实现数据畅通。
        </p>
      </div>

      <div class="wholesale_img_box">
        <img class="wholesale_img" src="../assets/img/zhnm.png" alt="" />
      </div>
    </div>
    <!--  软硬件一体化  -->
    <div class="banners integration">
      <div class="wholesale_programme_title">
        <div class="wholesale_programme_title_text wholesale_programme_title_text3">
          软硬件一体化
          <img src="../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>

      <div class="wholesale_text">
        <p>以标准信息平台建设为支撑，软件自主研发，硬件大厂OEM，软硬件深度结合为标准；</p>
        <p>
          结合新零售运营经验：支付服务全面、会员玩法多样、线上商城便捷；提供专属于农贸市场的一站式、精细化、数字化的降本增效解决方案。
        </p>
        <p>并为客户提供五星售后服务体系，为农贸市场数智化转型保驾护航。</p>
      </div>

      <div class="wholesale_img_box">
        <img class="wholesale_img integration_img" src="../assets/img/yitihua.png" alt="" />
      </div>
    </div>
    <!--  市场APP小助手  -->
    <div class="app">
      <div class="app-main">
        <div class="wholesale_programme_title1">
          <div class="wholesale_programme_title_text1">
            市场APP小助手
            <img src="../assets/img/title3@2x.png" class="img1" alt="" />
          </div>
          <!-- <div class="zhexian1"></div> -->
        </div>
        <div class="app-list container2">
          <div class="app-left">
            <div class="left-list" style="margin-right: 30px">
              <div class="left-item" v-for="item in list" :key="item.id">
                <div class="left-item-img">
                  <img :src="item.img" alt="" />
                </div>
                <div class="left-item-text">
                  <div class="left-item-title">{{ item.title }}</div>
                  <div class="left-item-intro">{{ item.intro }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="app-right">
            <img src="@/assets/img/sc_app@2x.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!--  商户APP小助手  -->
    <div class="merchant container">
      <div class="merchant-main container1">
        <div class="wholesale_programme_title1">
          <div class="wholesale_programme_title_text1">
            商户APP小助手
            <img src="../assets/img/title3@2x.png" class="img1" alt="" />
          </div>
          <div class="zhexian"></div>
        </div>
      </div>
      <div class="app-list container2">
        <div class="app-right" style="margin-right: 30px; margin-top: -50px">
          <img src="@/assets/img/sh_app@2x.png" alt="" />
        </div>
        <div class="app-left" style="margin-top: -50px">
          <div class="left-list">
            <div class="left-item" v-for="item in app" :key="item.id">
              <div class="left-item-img">
                <img :src="item.img" alt="" />
              </div>
              <div class="left-item-text">
                <div class="left-item-title">{{ item.title }}</div>
                <div class="left-item-intro">{{ item.intro }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  成功案例  -->
    <!-- <success-case :bgColorBlue="true"></success-case> -->
  </div>
</template>

<script>
import SuccessCase from '@/components/solution/successCase'

export default {
  components: {
    SuccessCase
  },
  data() {
    return {
      list: [
        {
          id: 1,
          img: require('@/assets/img/scapp_1@2x.png'),
          title: '数据查询',
          intro: '市场、商城、商户、会员多维度报表, 给市场运营提供数据支持'
        },
        {
          id: 2,
          img: require('@/assets/img/scapp_2@2x.png'),
          title: '市场巡检',
          intro: '移动巡检，实时高效, 给市场巡查充分提供保障和便利'
        },
        {
          id: 3,
          img: require('@/assets/img/scapp_3@2x.png'),
          title: '会员助手',
          intro: '一键查询会员信息，关联会员账户, 让数据打通不再是难题'
        },
        {
          id: 4,
          img: require('@/assets/img/scapp_4@2x.png'),
          title: '电子商城',
          intro: '一键配送发货, 让生活的购物方便又舒心'
        }
      ],
      app: [
        {
          id: 1,
          img: require('@/assets/img/scapp_1@2x.png'),
          title: '数据查询',
          intro: '商户、商城、会员、商品多维度报表, 给商户的管理保驾护航'
        },
        {
          id: 2,
          img: require('@/assets/img/shapp_2@2x.png'),
          title: '商品管理',
          intro: '线上线下商品移动管理，快速定价, 上下架商品，让商品查询快捷简单'
        },
        {
          id: 3,
          img: require('@/assets/img/scapp_4@2x.png'),
          title: '电子商城',
          intro: '一键配货，清晰的订单，为送货节省更多时长，把服务做到尽善尽美'
        }
      ]
    }
  }
}
</script>

<style scoped>
.smart {
  width: 100%;
  min-width: 1680px;
  margin: 0 auto;
}

.container1 {
  width: 1200px;
  margin: 0 auto;
}

.container2 {
  width: 1000px;
  margin: 0 auto;
}

.banner {
  width: 100%;
  margin: 0 auto 50px;
}

.banner1 {
  width: 100%;
  /* background: url('../assets/img/banner_SmartPark.png') no-repeat center center; */
  background-size: cover;
  position: relative;
  height: auto;
}

.banner1 img:first-child {
  width: 100%;
  height: auto;
}

.banner1 img:last-child {
  cursor: pointer;
  width: 174px;
  height: auto;
  position: absolute;
  left: 18.75%;
  top: 65.4%;
}

.jianbian {
  width: 100%;
  /* background: linear-gradient(to right #154AC3, #1B329A ); */
  background: linear-gradient(to left, #1843db, #6c8ef4);
  /* background: linear-gradient(to bottom right, #154AC3 , #1B329A); */
}

.banners_img {
  width: 1200px;
  height: 599px;
  margin: 0 auto;
}

.banners {
  background: #f7fbff;
  padding-top: 73px;
  padding-bottom: 48px;
}

.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -17px;
  z-index: -1;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}

.wholesale_text {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
  line-height: 26px;
}

.wholesale_img {
  width: 1200px;
  height: 843px;
}

.wholesale_img_box {
  width: 1200px;
  margin: 50px auto;
}

.wholesale_programme_title1 {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text1 {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -1px;
  z-index: -1;
}

.wholesale_programme_title_text1 .img1 {
  right: -3px;
}

.wholesale_programme_title_text2 {
  width: 330px;
}

.wholesale_programme_title_text3 {
  width: 182px;
}

.zhexian1 {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}

.wholesale_text1 {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
  line-height: 26px;
}

.wholesale_img1 {
  width: 1200px;
  height: 582px;
}

.wholesale_img_box1 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 50px;
}

.app {
  background: #f7fbff;
  overflow: hidden;
}

.app-main {
  margin: 73px auto;
}

.app-list {
  margin-top: 50px;
  margin-bottom: 50px;
  /* margin-right: 20px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-right {
  width: 312px;
  height: 580px;
}

.app-right img {
  width: 100%;
  height: 100%;
}

.left-item {
  display: flex;
  width: 610px;
  height: 118px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  align-items: center;
  margin-bottom: 20px;
}

.left-item:hover {
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.07);
}

.left-item-img {
  width: 50px;
  height: 50px;
  margin-left: 50px;
  margin-right: 20px;
}

.left-item-img img {
  width: 50px;
  height: 50px;
}

.left-item-title {
  width: 80px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}

.left-item-intro {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  margin-top: 10px;
}

.merchant {
  overflow: hidden;
}

.merchant-main {
  /* margin: 100px auto; */
  margin-top: 73px;
}

.think_container {
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 84px auto 100px;
}

.think_container img {
  width: 30px;
  height: 28px;
  margin-right: 10px;
}

.think_item {
  display: flex;
  align-items: center;
}

.integration {
  background: none;
  padding-bottom: 0;
}

.integration_img {
  width: 1200px;
  height: 557px;
}
</style>
